/* eslint-disable react/jsx-filename-extension */
import { HTMLAttributes, ReactElement } from 'react';
import { RadioInputContainer as Container, Radio } from './styles';
import { CSSObject } from 'styled-components';

interface Props extends HTMLAttributes<HTMLInputElement> {
  isChecked?: boolean;
  name?: string;
  styles?: CSSObject;
}

export const RadioInput = ({
  isChecked,
  name,
  styles,
  ...rest
}: Props): ReactElement => {
  const defaultCheckedProp = typeof isChecked === 'boolean' ? isChecked : false;

  return (
    <Container isChecked={defaultCheckedProp} styles={styles}>
      <Radio
        type="radio"
        name={name}
        checked={defaultCheckedProp}
        styles={styles}
        {...rest}
      />
    </Container>
  );
};
